import axios from 'axios';
import {
    BASE_URL_SERVICE,
} from '../constants'

/* -------------------------------------------------------------------------- */
/*                               Get Propiedades                              */
/* -------------------------------------------------------------------------- */
export async function crearDudaInterna({ usuario_id, categoria_id, url_origen, asunto, descripcion }) {
    try {
		var config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				// 'content-type': 'application/form-data'
			}
		};
		var params = new URLSearchParams();
		params.append('usuario_id', usuario_id);
		params.append('categoria_id', categoria_id);
		params.append('url_origen', url_origen);
		params.append('descripcion', descripcion);
        params.append('asunto', asunto);
		const response = await axios.post(BASE_URL_SERVICE + 'alumno/crear_duda_interna', params, config);

		return response;
	} catch (error) {
		// throw error;
		return undefined;
	}
}
